var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C8.95 0.5 0 9.45 0 20.5C0 29.35 5.725 36.825 13.675 39.475C14.675 39.65 15.05 39.05 15.05 38.525C15.05 38.05 15.025 36.475 15.025 34.8C10 35.725 8.7 33.575 8.3 32.45C8.075 31.875 7.1 30.1 6.25 29.625C5.55 29.25 4.55 28.325 6.225 28.3C7.8 28.275 8.925 29.75 9.3 30.35C11.1 33.375 13.975 32.525 15.125 32C15.3 30.7 15.825 29.825 16.4 29.325C11.95 28.825 7.3 27.1 7.3 19.45C7.3 17.275 8.075 15.475 9.35 14.075C9.15 13.575 8.45 11.525 9.55 8.775C9.55 8.775 11.225 8.25 15.05 10.825C16.65 10.375 18.35 10.15 20.05 10.15C21.75 10.15 23.45 10.375 25.05 10.825C28.875 8.225 30.55 8.775 30.55 8.775C31.65 11.525 30.95 13.575 30.75 14.075C32.025 15.475 32.8 17.25 32.8 19.45C32.8 27.125 28.125 28.825 23.675 29.325C24.4 29.95 25.025 31.15 25.025 33.025C25.025 35.7 25 37.85 25 38.525C25 39.05 25.375 39.675 26.375 39.475C30.3456 38.135 33.7959 35.5834 36.2401 32.1794C38.6843 28.7754 39.9993 24.6906 40 20.5C40 9.45 31.05 0.5 20 0.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.4c5cfb7f28f807dd53999e4332be275b.svg";
export { ForwardRef as ReactComponent };